import { useParams } from 'react-router-dom'
import EditTicketForm from './EditTicketForm'
import { useGetTicketsQuery } from './ticketsApiSlice'
import { useGetUsersQuery } from '../users/usersApiSlice'
import useAuth from '../../hooks/useAuth'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'

const EditTicket = () => {
    useTitle('Edit-Ticket')

    const { id } = useParams()

    const { username, isProductManager, isSystemAnalyst } = useAuth()

    const { ticket } = useGetTicketsQuery("ticketsList", {
        selectFromResult: ({ data }) => ({
            ticket: data?.entities[id]
        }),
    })

    const { users } = useGetUsersQuery("ticketsList", {
        selectFromResult: ({ data }) => ({
            users: data?.ids.map(id => data?.entities[id])
        }),
    })

    if (!ticket || !users?.length) return <PulseLoader color={"#FFF"} />


    if (!isProductManager && !isSystemAnalyst) {
        if (ticket.username !== username) {
            return <p className="errmsg">No access</p>
        }
    }

    const content = 
        <div className="container w-[25rem] md:w-[80rem] h-[28rem] md:h-[37rem] mx-auto border-2 rounded-lg border-gray-400"> 
            <EditTicketForm ticket={ticket} users={users} />
        </div>
    return content
}
export default EditTicket